"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var use_stores_1 = require("hooks/use-stores");
var UserStore_1 = require("stores/UserStore");
var add_icon_yellow_svg_1 = __importDefault(require("res/img/add-icon-yellow.svg"));
var add_icon_blue_svg_1 = __importDefault(require("res/img/add-icon-blue.svg"));
var AddButton = mobx_react_1.observer(function (_a) {
    var label = _a.label, onClick = _a.onClick;
    var userStore = use_stores_1.useStores().userStore;
    var theme = userStore.data.settings.generalSettings.theme;
    return (react_1.default.createElement("button", { type: 'button', "aria-label": label, title: label, onClick: onClick, className: 'add-button flex flex-row' },
        react_1.default.createElement("img", { src: theme === UserStore_1.Themes.DARK ? add_icon_yellow_svg_1.default : add_icon_blue_svg_1.default, alt: label }),
        react_1.default.createElement("span", null, label)));
});
exports.default = AddButton;
